import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import { useVersionSensitiveNavigate } from "hooks/useVersionSensitiveNavigate";
import { setTypedItem } from "reduxStore/slices/nav-bar/actions";

export const useSearchPostcode = (currentValue: string) => {
  const [ cookies, setCookie ] = useCookies([ "location" ]);
  const dispatch = useDispatch();
  const navigate = useVersionSensitiveNavigate();


  return () => {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: currentValue }, (results, status) => {
      if (results && (status === google.maps.GeocoderStatus.OK)) {
        const { lat, lng } = results[0].geometry.location;
        const location = {
          lat: lat() || null,
          lng: lng() || null,
          name: results[0].formatted_address || currentValue
        };
        setCookie("location", JSON.stringify(location), {
          domain: process.env.REACT_APP_COOKIE_DOMAIN,
          path: "/"
        });
        dispatch(setTypedItem({ value: "" }));
        navigate("/map?itemSearch");
      }
    });
  };
};